import React, { useContext, useState } from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import CheckIcon from 'components/material-symbol/icons/Check'
import Dialog from 'components/dialog'
import RecordBookingPaymentForm from 'components/record-booking-payment-form'
import RecordBookingPaymentParticipantSummary from './participant-summary'
import { RefetchContext } from 'lib/utils/refetchContext'
import { onPayment } from 'lib/utils'
import { makeStyles } from '@material-ui/core/styles'

const FORM_ID = 'record-booking-payment-form'

const useStyles = makeStyles(theme => ({
  titleRoot: {
    padding: theme.spacing(3, 3, 1),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.3,
    color: '#172024',
  },
  subtitle: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.75),
  },
  content: {
    padding: theme.spacing(1, 3, 2),
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))

const RecordBookingPaymentDialog = ({
  enrollment,
  eventTitle,
  eventDate,
  participantName,
  defaultAmountInCents,
  acceptOnlinePayments,
  trigger,
}) => {
  const classes = useStyles()
  const refreshBookings = useContext(RefetchContext)
  const [isChargeMode, setIsChargeMode] = useState(false)

  const onPaymentSuccess = () => {
    onPayment(refreshBookings)
  }

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      trigger={trigger}
      showCloseButton
      onClose={() => setIsChargeMode(false)}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              Event Transaction
            </Typography>
            <Typography className={classes.subtitle}>
              Record payment for this event
            </Typography>
          </DialogTitle>
          <DialogContent classes={{ root: classes.content }}>
            <RecordBookingPaymentParticipantSummary
              participantName={participantName}
              eventTitle={eventTitle}
              eventDate={eventDate}
            />
            <RecordBookingPaymentForm
              formId={FORM_ID}
              enrollment={enrollment}
              defaultAmountInCents={defaultAmountInCents}
              acceptOnlinePayments={acceptOnlinePayments}
              onChargeModeChange={setIsChargeMode}
              onPaymentSuccess={() => {
                setIsChargeMode(false)
                closeDialog()
                onPaymentSuccess && onPaymentSuccess()
              }}
            />
          </DialogContent>
          {!isChargeMode ? (
            <DialogActions className={classes.actions}>
              <Button
                color="primary"
                size="large"
                onClick={() => {
                  setIsChargeMode(false)
                  closeDialog()
                }}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                size="large"
                type="submit"
                form={FORM_ID}
                startIcon={<CheckIcon fontSize="small" />}
              >
                Save
              </Button>
            </DialogActions>
          ) : null}
        </>
      )}
    </Dialog>
  )
}

export default RecordBookingPaymentDialog
